"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathnameToPathList = void 0;
var pathnameToPathList = function (pathname) {
    return pathname.split('/').filter(function (s) { return s !== ''; });
};
exports.pathnameToPathList = pathnameToPathList;
